import { connect, MapStateToProps } from 'react-redux';
import { Props } from './BrowsePage';
import { AppState } from '../../../../types/store';
import {
  getCurrentFeedType,
  getOrderSubnavigation,
  getTopicFilter,
  getTopicFilterTopic,
} from '../../../../selectors/page';

export type StateProps = Pick<
  Props,
  'hasOrderSubnav' | 'feedType' | 'topicFilter' | 'topicFilterTopic'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  hasOrderSubnav: !!getOrderSubnavigation(state),
  feedType: getCurrentFeedType(state),
  topicFilter: getTopicFilter(state),
  topicFilterTopic: getTopicFilterTopic(state),
});

export default connect(mapStateToProps);
